import i from "react";
import { S as b } from "./chunk.C6mRe6RE.js";
import n from "@mui/material/Grid";
const x = ({
  selectionCards: f,
  value: a,
  onChange: o,
  orientation: s = "landscape",
  multiple: d = !1,
  ...t
}) => {
  const m = (r) => d && Array.isArray(a) ? a.some((e) => e === r) : a === r, l = (r, e) => {
    d && Array.isArray(a) ? a.some((c) => c === e) ? o(
      r,
      a.filter((c) => c !== e)
    ) : o(r, [...a, e]) : o(r, e);
  };
  return /* @__PURE__ */ i.createElement(
    n,
    {
      id: t.id,
      "data-testid": t["data-testid"],
      spacing: 2,
      container: !0,
      ...t.GridProps
    },
    f.map((r) => s === "portrait" ? /* @__PURE__ */ i.createElement(
      n,
      {
        xs: !0,
        item: !0,
        key: r.value,
        ...r.GridProps
      },
      /* @__PURE__ */ i.createElement(
        b,
        {
          error: t.error,
          disabled: t.disabled,
          "aria-label": t["aria-label"],
          ...r,
          checked: m(r.value),
          orientation: "portrait",
          onClick: (e) => l(e, r.value),
          variant: d ? "checkbox" : "radio"
        }
      )
    ) : /* @__PURE__ */ i.createElement(n, { xs: !0, item: !0, key: r.value, ...r.GridProps }, /* @__PURE__ */ i.createElement(
      b,
      {
        error: t.error,
        disabled: t.disabled,
        "aria-label": t["aria-label"],
        ...r,
        checked: m(r.value),
        orientation: "landscape",
        onClick: (e) => l(e, r.value),
        variant: d ? "checkbox" : "radio"
      }
    )))
  );
};
export {
  x as S
};
